var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { style: { marginTop: "2px" } },
        [
          _vm._l(_vm.sgrouplist, function(item) {
            return _c(
              "div",
              {
                key: item.syssgid,
                staticClass: "current-background",
                style: { background: item.sgroupcolor },
                on: {
                  click: function($event) {
                    return _vm.handleCheckSeatGroup(item)
                  }
                }
              },
              [_vm._v(" " + _vm._s(item.sgroupname))]
            )
          }),
          _c(
            "div",
            {
              staticClass: "current-settings",
              staticStyle: { "margin-left": "100px" }
            },
            [_vm._v("當前設置的座位分組為:")]
          ),
          _c(
            "div",
            {
              staticClass: "current-background",
              style: { background: _vm.selectedSeatGroup.sgroupcolor }
            },
            [_vm._v(_vm._s(_vm.selectedSeatGroup.sgroupname))]
          ),
          _c(
            "a-dropdown",
            {
              staticStyle: { float: "right" },
              scopedSlots: _vm._u([
                {
                  key: "overlay",
                  fn: function() {
                    return [
                      _c(
                        "a-menu",
                        [
                          _c(
                            "a-menu-item",
                            { key: "1", on: { click: _vm.handleAddGroup } },
                            [_vm._v("新增分組")]
                          ),
                          _c(
                            "a-menu-item",
                            { key: "2", on: { click: _vm.handleEditGroup } },
                            [_vm._v("修改分組")]
                          ),
                          _c(
                            "a-menu-item",
                            { key: "3", on: { click: _vm.handleDelGroup } },
                            [_vm._v("刪除分組")]
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c(
                "a-button",
                [
                  _vm._v("\n             設定分組\n             "),
                  _c("a-icon", {
                    staticStyle: { "margin-left": "8px" },
                    attrs: { type: "down" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "a-tabs",
        {
          attrs: { "hide-add": "", "active-key": _vm.activeKey },
          on: { change: _vm.handleClickTab }
        },
        _vm._l(_vm.FloorAreaList, function(pane) {
          return _c(
            "a-tab-pane",
            {
              key: pane.sysfloorid,
              attrs: {
                forceRender: "true",
                tab: pane.floorname,
                closable: pane.closable
              }
            },
            [
              _c(
                "div",
                { style: { marginTop: "5px" } },
                [
                  _c(
                    "a-radio-group",
                    {
                      attrs: {
                        defaultValue: _vm.active,
                        "button-style": "solid"
                      },
                      on: { change: _vm.handleAreaChange },
                      model: {
                        value: _vm.active,
                        callback: function($$v) {
                          _vm.active = $$v
                        },
                        expression: "active"
                      }
                    },
                    _vm._l(pane.areas, function(item) {
                      return _c(
                        "a-radio-button",
                        {
                          key: item.sysareaid,
                          attrs: {
                            "button-style": "solid",
                            value: item.sysareaid
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.areaname) +
                              "\n            "
                          )
                        ]
                      )
                    }),
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { float: "right" } },
                    [
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-left": "8px" },
                          on: {
                            click: function($event) {
                              return _vm.SettingGroupSeatData("add")
                            }
                          }
                        },
                        [_vm._v("設置座位分組")]
                      ),
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-left": "8px" },
                          on: {
                            click: function($event) {
                              return _vm.SettingGroupSeatData("del")
                            }
                          }
                        },
                        [_vm._v("刪除座位分組")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "main" }, [
                _c("div", { staticClass: "main-content" }, [
                  _c("div", { staticClass: "select-hbody" }, [
                    _c(
                      "div",
                      { staticClass: "tdbody-line" },
                      _vm._l(_vm.maxcolqty, function(item, pk) {
                        return _c(
                          "div",
                          {
                            key: pk,
                            staticClass: "colno",
                            on: {
                              click: function($event) {
                                return _vm.clickData("rows", _vm.maxrowqty, pk)
                              }
                            }
                          },
                          [_vm._v(" " + _vm._s(pk + 1) + "列")]
                        )
                      }),
                      0
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "tdbody-coln" },
                    _vm._l(_vm.maxrowqty, function(item, hk) {
                      return _c(
                        "div",
                        {
                          key: hk,
                          staticClass: "rowno",
                          on: {
                            click: function($event) {
                              return _vm.clickData("cols", hk, _vm.maxcolqty)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(hk + 1) + "排")]
                      )
                    }),
                    0
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "select-area",
                      on: {
                        mousedown: _vm.down,
                        mousemove: _vm.move,
                        mouseup: _vm.upan
                      }
                    },
                    [
                      _c("div", {
                        ref: "movable",
                        refInFor: true,
                        staticClass: "move",
                        style: _vm.myStyle
                      }),
                      _vm._l(_vm.subset, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "list" },
                          _vm._l(item, function(val, pk) {
                            return _c(
                              "div",
                              { key: pk, staticClass: "oplist" },
                              [
                                val.status === "0" ||
                                val.status === "3" ||
                                val.status === "4" ||
                                val.status === "5"
                                  ? _c("div", {
                                      ref: "seats_" + pane.sysfloorid,
                                      refInFor: true,
                                      staticClass: "item",
                                      class:
                                        _vm.selected.indexOf(
                                          pk + 1 + index * _vm.maxcolqty
                                        ) > -1
                                          ? "selected"
                                          : "",
                                      style: {
                                        border: _vm.bordersize + val.sgroupcolor
                                      },
                                      attrs: { id: val.sysid }
                                    })
                                  : _c(
                                      "div",
                                      {
                                        ref: "seats_" + pane.sysfloorid,
                                        refInFor: true,
                                        staticClass: "emptyseat",
                                        class:
                                          _vm.selected.indexOf(
                                            pk + 1 + index * _vm.maxcolqty
                                          ) > -1
                                            ? "selected"
                                            : "",
                                        attrs: { id: val.sysid }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(val.remark) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                              ]
                            )
                          }),
                          0
                        )
                      })
                    ],
                    2
                  )
                ])
              ])
            ]
          )
        }),
        1
      ),
      _c("seat-group-modal", { ref: "modalForm", on: { ok: _vm.modalFormOk } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }